module.exports = __webpack_public_path__ + "static/media/loop.82baf3cd.mp3";